<template>
  <div class="">
    <headerBar :activeIndex="activeIndex"></headerBar>
    <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner>
    <div class="guideDetail">
      <div
        class="main-content1 pc"
        style="padding-top: 30px; padding-bottom: 30px"
      >
        <div
          style="
            width: 100%;
            line-height: 30px;
            padding: 40px;
            background: #fff;
          "
        >
          <div class="list-tit" style="margin-bottom: 20px">
            <div style="font-size: 20px">
              <span v-if="id === 1">防疫指南</span>
              <span v-if="id === 2">就医流程</span>
            </div>
          </div>
          <!-- <div class="big-title" style="margin-bottom: 30px;font-size:16px;border-bottom:1px solid #999;padding-bottom:20px;">
              <div class="big-name" v-if="id === 1">就医指南</div>
              <div class="big-name" v-if="id === 2">就医流程</div>
          </div> -->
          <div
            v-html="detail.content"
            style="min-height: 500px; padding: 0 200px"
          ></div>
        </div>
        <!-- <ul>
          <li>
            <a href="#">其他需求</a>
            <p> 
              <a href="https://www.baidu.com">其他需求</a>
            </p>
          </li>
        </ul> -->
      </div>
      <div
        class="main-content1 mobile"
        style="padding-top: 10px; padding-bottom: 30px"
      >
        <div style="width: 100%; line-height: 30px; background: #fff">
          <div class="list-tit" style="margin-bottom: 10px">
            <div style="font-size: 18px; padding: 0 10px">
              <span v-if="id === 1">防疫指南</span>
              <span v-if="id === 2">就医流程</span>
            </div>
          </div>
          <!-- <div class="big-title" style="margin-bottom: 30px;font-size:16px;border-bottom:1px solid #999;padding-bottom:20px;">
              <div class="big-name" v-if="id === 1">就医指南</div>
              <div class="big-name" v-if="id === 2">就医流程</div>
          </div> -->
          <div
            v-html="detail.content"
            style="min-height: 500px; padding: 0"
          ></div>
        </div>
        <!-- <ul>
          <li>
            <a href="#">其他需求</a>
            <p> 
              <a href="https://www.baidu.com">其他需求</a>
            </p>
          </li>
        </ul> -->
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import RightBar from "@/components/rightBar.vue";
import { getmenudetail, guidedetail } from "@/api/common";
export default {
  name: "new",
  components: { banner, footerBar, headerBar, RightBar },
  data() {
    return {
      showDialog: false,
      activeIndex: "news",
      info: { carousel: "", Mcarousel: "" },
      detail: null,
      id: null,
    };
  },
  mounted() {
    getmenudetail({ id: 8 }).then((res) => {
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
        res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
    });
    this.id = this.$route.query.id;
    guidedetail({ id: this.$route.query.id }).then((res) => {
      this.detail = res.data[0];
      this.postMessage(
          "东莞黄家圣幸中医医院",
          "黄家圣幸肾病专科医院是黄家圣幸集团下属肾病综合专科医院，秉承“一切为了人类健康”的使命，突出中医特色，发挥专科特长，坚持“一切以治愈为目的”的服务宗旨，已建成肾病专科、免疫性疾病专科。运用中医特效疗法，在IgA肾病、肾炎、慢性肾病领域疗效显著，在类风湿性关节炎及强直性脊柱炎领域建立诊疗优势。黄家圣幸肾病专科医院，将肩负着“推进健康中国建设，促进中医药传承与发展”的历史使命，努力创建国内一流、国际知名的现代化中医院",
          window.location.href,
          "http://sensin-his-website.oss-cn-beijing.aliyuncs.com/live/dcfa436bd8fbf0c0393b7c8ae645baa3e47fdbfe.jpg"
        );
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.guideDetail .newImg {
  height: 260px;
}
.guideDetail .lishu {
  font-family: "Microsoft YaHei";
  font-size: 24px;
  position: relative;
}
.guideDetail .new-Bar {
  width: calc(100% / 3 - 20px);
  background: #f1ece6;
  float: left;
  margin-right: 10px;
  margin-bottom: 30px;
}
.guideDetail .new-Bar:nth-child(3n) {
  margin-right: 0;
}
.guideDetail .new-content {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.guideDetail .videoBar {
  position: relative;
  margin-bottom: 10px;
}
.guideDetail .videoBar-title {
  position: absolute;
  width: 100%;
  bottom: 5px;
  left: 0;
  height: 90%;
  color: #fff;
  text-align: center;
  opacity: 0;
  padding: 5px 0;
  font-size: 12px;
}
.guideDetail .videoBar-title:hover {
  opacity: 1;
  animation: fade-in;
  animation-duration: 0.5s; /*动画持续时间*/
  -webkit-animation: fade-in 0.5s; /*针对webkit内核*/
}
.guideDetail .jiuyi {
  margin: 10px 0;
  padding: 10px;
  font-size: 16px;
}
@media screen and (max-width: 600px) {
  .newImg {
    width: 90%;
    margin: 5px auto;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news/guideDetail.vue